module.exports = __webpack_public_path__ + "static/media/sass.fcf40d6a.png";